// Temporary workaround. Resolve ASAP. Do not add more ignores like this.
// eslint-disable-next-line eslint-comments/no-restricted-disable
// eslint-disable-next-line @nx/enforce-module-boundaries
import { api } from '@marketplace-web/core-api/core-api-client-util'

// Temporary workaround. Resolve ASAP. Do not add more ignores like this.
// eslint-disable-next-line eslint-comments/no-restricted-disable
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AuthenticateUserError } from '@marketplace-web/registration/identity-data'

import { Oauth2UserLoginArgs } from '../types/oauth2-user-login-args'

export const oauth2UserLogin = (args: Oauth2UserLoginArgs) =>
  api.post<{ redirect_to: string }, AuthenticateUserError>('/oauth2', args)
